/**
 * Store links for the Signalist browser extension (PREC-3815). Edge users get
 * the Edge Add-ons listing — Edge can install from the Chrome Web Store, but
 * the native listing installs without the "allow other stores" interstitial.
 */
export const CHROME_EXTENSION_STORE_URL =
	"https://chromewebstore.google.com/detail/meghhmclgjhapbkhdkhonjjnpadgagbn";

export const EDGE_EXTENSION_STORE_URL =
	"https://microsoftedge.microsoft.com/addons/detail/pndhcnbcpniojghogjihbgbpmcnphkap";

/**
 * Chromium-based Edge identifies itself with an `Edg/<version>` token (the
 * legacy tokens `Edge/` and `EdgA/`/`EdgiOS/` belong to retired or non-desktop
 * builds that cannot install extensions from these stores anyway).
 */
export const isEdgeBrowser = (userAgent: string): boolean => /\bEdg\//.test(userAgent);

export const getExtensionStoreUrl = (userAgent: string = navigator.userAgent): string =>
	isEdgeBrowser(userAgent) ? EDGE_EXTENSION_STORE_URL : CHROME_EXTENSION_STORE_URL;
